import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledTextCTAButton, StyledTextCTAIconWrapper, StyledTextCTALink, StyledTextCTAText } from './TextCTA.styles';
const isCTAPropsWithChildren = (props)=>Boolean(props?.children);
export const TextCTA = (props)=>{
    const { ariaLabel, as, className, 'data-dd-action-name': ddAction, 'data-testid': testId, icon, isInlineLink = false, isSlim, tabIndex, variant = 'default' } = props;
    const children = isCTAPropsWithChildren(props) ? props.children : undefined;
    if (as === 'a') {
        const { href, isDownload = false, onClick, target } = props;
        return /*#__PURE__*/ _jsxs(StyledTextCTALink, {
            $isInlineLink: isInlineLink,
            $isSlim: isSlim,
            $variant: variant,
            "aria-label": ariaLabel,
            className: className,
            "data-dd-action-name": ddAction,
            "data-testid": testId,
            download: isDownload,
            href: href,
            onClick: onClick,
            tabIndex: tabIndex,
            target: target,
            children: [
                icon && /*#__PURE__*/ _jsx(StyledTextCTAIconWrapper, {
                    children: icon
                }),
                children && /*#__PURE__*/ _jsx(StyledTextCTAText, {
                    children: children
                })
            ]
        });
    }
    const { isDisabled, isLoading, onClick, type } = props;
    return /*#__PURE__*/ _jsxs(StyledTextCTAButton, {
        $isInlineLink: isInlineLink,
        $isSlim: isSlim,
        $variant: variant,
        "aria-label": ariaLabel,
        as: "button",
        className: className,
        "data-dd-action-name": ddAction,
        "data-testid": testId,
        disabled: isDisabled || isLoading,
        onClick: onClick,
        tabIndex: tabIndex,
        type: type,
        children: [
            icon && /*#__PURE__*/ _jsx(StyledTextCTAIconWrapper, {
                children: icon
            }),
            children && /*#__PURE__*/ _jsx(StyledTextCTAText, {
                children: children
            })
        ]
    });
};

//# sourceMappingURL=TextCTA.js.map